import styled from "styled-components";
import { Colors } from "../../../shared/colors/colors";
import { StyleSheet } from "@react-pdf/renderer";

export const Container = styled.div`
  display: flex;
  width: 90vw;
  flex-direction: column;
  height: 100%;
  gap: 16px;
`;

export const ContainerPages = styled.div`
  justify-content: center;
  align-items: center;
  position: relative;
`;

export const ButtonTab = styled.button<{
  active: boolean;
  disabled: boolean;
}>`
  border: 1px solid ${Colors.borderMenu};
  padding: 12px 16px 12px 16px;
  gap: 6px;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.4px;
  text-decoration: none;
  color: ${({ active, disabled }) =>
    active ? Colors.white : disabled ? Colors.borderMenu : Colors.black};
  background-color: ${({ active }) => (active ? Colors.primary : Colors.inactiveTabMenu)};

  cursor: ${({ disabled, active }) => (disabled && !active ? "not-allowed" : "pointer")};

  &:hover {
    background-color: ${Colors.hoverTabMenu};
  }

  &:first-child {
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
  }

  &:last-child {
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
  }
`;

export const Menu = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  height: 44px;
`;

export const OptionsContainer = styled.div`
  padding: 0;
  margin: 0;
  width: 100%;
`;

// Container do título e botão
export const TitleAndButton = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const ContribuinteContainer = styled.div`
  font-size: 18px;
  font-weight: bold;
  color: ${Colors.label};
`;

export const ContribuinteName = styled.span`
  color: ${Colors.primary};
  background-color: ${Colors.contribuinteNameBackground};
  padding: 2px 6px;
  border-radius: 4px;
`;

export const ContainerButton = styled.div`
  display: flex;
  margin-left: auto;
  gap: 16px;
`;

export const ContainerRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 44px;
`;

export const AppliedFilters = styled.div`
  display: flex;
  flex-direction: row;
  width: 90vw;
  min-height: 48px;
  align-items: center;
  padding: 8px 16px;
  gap: 16px;
  border-radius: 8px;
  border: 1px solid rgba(229, 231, 235, 1);
  box-sizing: border-box;
  background: rgba(249, 250, 251, 1);
  font-family: 'Work Sans', sans-serif;
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  color: rgba(107, 114, 128, 1);
  margin-top: 16px;

  & > p {
    margin: 0;
    white-space: nowrap;
  }

  & > i.fa.fa-filter {
    color: rgba(107, 114, 128, 1);
  }
`;

export const FiltersContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
`;

export const FilterItem = styled.div`
  border: 2px solid rgba(147, 197, 253, 1);
  border-radius: 4px;
  padding: 4px 8px;
  background-color: rgba(239, 246, 255, 1);
  display: flex;
  align-items: center;
  gap: 5px;
`;

export const FilterKey = styled.span`
  font-family: 'Work Sans', sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  text-align: left;
`;

export const FilterValue = styled.span`
  font-family: 'Work Sans', sans-serif;
  font-size: 14px;
  font-weight: 700;
  line-height: 20px;
  text-align: left;
`;

export const FilterRemoveButton = styled.button`
  background: none;
  border: none;
  font-weight: bold;
  font-size: 16px;
  cursor: pointer;
`;

export const RelatorioStyles = StyleSheet.create({
  page: { padding: 30, position: "relative" },

  // Cabeçalho
  header: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    marginBottom: 20,
    position: "relative",
    paddingLeft: 60, // Added padding to prevent overlap with logo
  },
  logoContainer: {
    position: "absolute",
    left: 0, // Changed from 80 to 0
    top: 0,
    width: 45,
    height: 45,
  },
  logo: {
    width: 45,
    height: 45,
  },
  headerText: {
    flex: 1,
    alignItems: "center",
    marginLeft: 20, // Added margin to create more space from the logo
  },
  institution: { fontSize: 12, fontWeight: "bold" },
  details: { fontSize: 10 },
  title: { fontSize: 14, fontWeight: "bold", marginTop: 10 },

  // Filtros
  filtersMainContainer: {
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    height: "auto",
    width: "auto",
  },
  filters: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    marginTop: 8,
    gap: 8,
  },
  filterText: {
    fontSize: 12,
  },
  filterContainer: {
    display: "flex",
    alignItems: "center",
    flexDirection: "row",
    gap: 5,
  },
  filterTextBold: {
    fontSize: 12,
    fontWeight: "bold",
  },
  // Tabela
  table: {
    display: 'flex',
    width: 'auto',
    borderStyle: 'solid',
    borderWidth: 1,
    borderColor: '#000',
    marginBottom: 10,
  },
  row: {
    flexDirection: 'row',
    borderBottomWidth: 1,
    borderBottomColor: '#000',
    borderBottomStyle: 'solid',
    width: '100%',
  },
  cellHeader: {
    backgroundColor: '#f0f0f0',
    fontWeight: 'bold',
    fontSize: 10,
    padding: '5px 4px',
    borderRightWidth: 1,
    borderRightColor: '#000',
    borderRightStyle: 'solid',
  },
  cell: {
    fontSize: 10,
    padding: '5px 4px',
    borderRightWidth: 1,
    borderRightColor: '#000',
    borderRightStyle: 'solid',
  },
  cellMerged: {
    margin: 'auto',
    marginTop: 5,
    fontSize: 10,
    padding: '5px 4px',
    textAlign: 'center',
    width: '100%',
    borderBottom: '1px solid #000',
  },

  // Rodapé
  footer: {
    position: "absolute",
    bottom: 30, // Increased from 20 to 30
    left: 30,
    right: 30,
    fontSize: 9,
    flexDirection: "row",
    justifyContent: "space-between",
    color: "#555",
  },
});